import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface LegendItem {
  type?: string;
  fillColor: string;
  itemColor: string;
  cssClass  ?: string;
  text: string;
  textColor?: string;
  fillStroke?: string;
  tooltipText?: string;
  isInline: boolean;
}

@Component({
  selector: 'ispm-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LegendComponent implements OnInit {
  @Input() title: string;
  @Input() items: LegendItem[];
  @Input() translationPrefix: string;
  @Input() alignRight = false;
  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  public getValueOrItsTranslation(legendItem: LegendItem): string {
    return this.translationPrefix ? this.translate.instant(`${this.translationPrefix}_${legendItem.text}`) : legendItem.text;
  }

}
